export class CatBusinessLineModel {
    public iBusinessLineId?: number;
    public vDescription?: string;
    public iActiveId?: number;
    public vCreateUserId?: string;
    public dtCreateDate?: string;
    public vModifUserId?: string;
    public dtModifDate?: string;
}
